import { RefCallback, useCallback } from 'react'

import { BoxModalContextValue } from '../types'

type UsePrefetchOnMouseEnterProps = {
  context: BoxModalContextValue
}

export function usePrefetchOnMouseEnter({ context }: UsePrefetchOnMouseEnterProps) {
  const { enablePrefetch, initialized } = context

  const listener: EventListener = useCallback(() => {
    enablePrefetch()
  }, [enablePrefetch])

  const prefetchOnMouseEnterRef: RefCallback<HTMLElement> = useCallback(
    (element) => {
      if (initialized && element) {
        element.addEventListener('mouseenter', listener)
      }
    },
    [initialized, listener]
  )

  return { prefetchOnMouseEnterRef }
}
